import { Button, Flex, Text } from '@mantine/core';
import { CaretLeftIcon } from '@phosphor-icons/react';
import type { FC } from 'react';

export const BackButton: FC<{ text: string; onClick: () => void }> = ({ text, onClick }) => {
  return (
    <Button
      c="gigi-black"
      h={32}
      radius="xl"
      styles={{ root: { borderColor: '#E1E1E1' } }}
      variant="outline"
      onClick={onClick}
    >
      <Flex align="center" gap={2} justify="center">
        <CaretLeftIcon size={16} />
        <Text c="gigi-grey-text" size="xxs">
          {text}
        </Text>
      </Flex>
    </Button>
  );
};
